// extracted by mini-css-extract-plugin
module.exports = {"responsive":"responsive_responsive_3d4WJ","responsiveContent":"responsive_responsiveContent_3CEWb"};